import { useSetRecoilState } from "recoil";
import notificationState from "../states/notificationState";

const useNotification = () => {
    const setNotification = useSetRecoilState(notificationState);

    const notifySuccess = (msg) => {
        setNotification({
            severity: "success",
            msg: msg,
            open: true,
        });
    };

    const notifyFailure = (msg) => {
        setNotification({
            severity: "error",
            msg: msg,
            open: true,
        });
    };

    const notifyWarning = (msg) => {
        setNotification({
            severity: "warning",
            msg: msg,
            open: true,
        });
    };

    return {
        notifySuccess,
        notifyFailure,
        notifyWarning,
    };
};

export default useNotification;
